<template lang="pug">
.exchange-float(
  v-if="hasFloat"
  :class="{ 'is-collapsed': collapsed }"
  @click="handleClick"
)
  img.exchange-float-img(
    :src="floatInfo.openFloatImage"
    alt="兑换浮标"
  )
</template>

<script>
import { anchorToEl } from '@/utils/tools';
import { queryWelfareCommonFloat } from '@/api/fuli';
import { getTokenAndKey } from '@/utils/index';
import { Navigator } from '@hb/h5-navigator';

export default {
  name: 'ExchangeFloat',
  props: {
    moduleKey: {
      type: String,
      default: '',
    },
    moduleData: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: {
    titleBarHeight: { from: 'titleBarHeight', default: () => () => 0 },
  },
  data() {
    return {
      floatInfo: {},
      collapsed: false,
    };
  },
  computed: {
    hasFloat() {
      const { openFloatImage } = this.floatInfo || {};
      return !!openFloatImage;
    },
  },
  mounted() {
    this.fetchFloatInfo();
  },
  beforeDestroy() {
    this.unbindScroll();
  },
  methods: {
    async fetchFloatInfo() {
      try {
        const { token } = await getTokenAndKey();
        const result = await queryWelfareCommonFloat({ token });
        this.floatInfo = (result && result.data) || {};
      } catch {
        this.floatInfo = {};
      }
      if (this.hasFloat) this.bindScroll();
    },
    // 滚动中收起，停止 500ms 后展开
    bindScroll() {
      this._idleTimer = null;
      this._scrollHandler = () => {
        if (!this.collapsed) this.collapsed = true;
        if (this._idleTimer) clearTimeout(this._idleTimer);
        this._idleTimer = setTimeout(() => {
          this.collapsed = false;
          this._idleTimer = null;
        }, 500);
      };
      window.addEventListener('scroll', this._scrollHandler, { passive: true });
    },
    unbindScroll() {
      if (this._scrollHandler) {
        window.removeEventListener('scroll', this._scrollHandler);
        this._scrollHandler = null;
      }
      if (this._idleTimer) {
        clearTimeout(this._idleTimer);
        this._idleTimer = null;
      }
    },
    // 浮标点击：jump 外跳；locate 滚动到目标模块
    handleClick() {
      const { actionType, moduleKey, jumpUrl } = this.floatInfo || {};
      if (actionType === 'locate' && moduleKey) {
        const titleBarH = this.titleBarHeight ? this.titleBarHeight() : 0;
        anchorToEl(moduleKey, titleBarH + 10);
      }
      if (actionType === 'jump' && jumpUrl) {
        Navigator.go(jumpUrl);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.exchange-float {
  position: fixed;
  right: -0.12rem;
  bottom: 0.72rem;
  z-index: 50;
  cursor: pointer;
  transform: translateX(0);
  transition: transform 400ms ease-out;

  .exchange-float-img {
    display: block;
    height: 0.64rem;
    width: auto;
  }

  // 收起：将整张图向右滑出
  &.is-collapsed {
    transform: translateX(calc(100% - 0.25rem));
    opacity: 0.2;
  }
}
</style>
